module.exports = "<div class=\"chnl-inv-hol-import-popup-wrapper\">\n\n  <lfwms-result-data-table [searchService]=\"importSearchService\" (buttonActionHandler)=\"handleButtonAction($event)\">\n  </lfwms-result-data-table>\n\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/channel-inv-hold-import-popup/channel-inv-hold-import-popup.component.html
// module id = ../../../../../src/app/shared/lookup/channel-inv-hold-import-popup/channel-inv-hold-import-popup.component.html
// module chunks = main